import { auth } from '@/firebase';
import { EventSourcePolyfill } from 'event-source-polyfill';

const URL = 'https://api.meshcommengineering.com/api/v1/';

class Data {
    static async get(dataID, token=null) {
        const response = await fetch(`${URL}data/options/${dataID}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.json();
    }

    static async post(body, token=null) {
        const response = await fetch(`${URL}data/`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        const responseData = await response.json();
        if (responseData.statusCode === 200) {
            let data = responseData.body.details.data;
            let pagination = responseData.body.details.pagination;
            while (pagination.hasNext) {
                const nextResponse = await fetch(`${URL}data/`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(pagination)
                });
                const nextResponseData = await nextResponse.json();
                data = data.concat(nextResponseData.body.details.data);
                pagination = nextResponseData.body.details.pagination;
            }
            return data;
        }
        else {
            throw new Error(responseData);
        }
    }

    static async stream(dataID, topic, token=null) {
        // Create the URL with path parameters
        const url = `${URL}stream/data/${encodeURIComponent(dataID)}/${encodeURIComponent(topic)}`;
        
        // Create a new EventSourcePolyfill with authentication header
        const eventSource = new EventSourcePolyfill(url, {
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`
            },
            withCredentials: true
        });
        
        return eventSource;
    }
}

export default Data;